module.exports = __webpack_public_path__ + "static/media/navigation.ced94f33.svg";